// 社区接口
import request from "@/config/_request";
import qs from "qs";

export function getScWorkContent(params) {
  return request({
    url: "/api/get/sc/work/content",
    params,
    method: "get",
  });
}


//获得用户自由创作作品列表
export function getWorkList(params) {
  return request({
    url: "/api/get/work/list",
    params,
    method: "get",
  });
}

//增加作品浏览量
export function updateScWorkLooks(params) {
  return request({
    url: "/api/update/sc/work/looks",
    data: qs.stringify(params),
    method: "post",
  });
}

//更新Jr作品浏览量
export function updateJrWorkLooks(params) {
  return request({
    url: "/api/update/jr/work/looks",
    data: qs.stringify(params),
    method: "post",
  });
}


//作品点赞数量更新
export function updateScWorkZanList(params) {
  return request({
    url: "/api/update/sc/work/zan/list",
    data: qs.stringify(params),
    method: "post",
  });
}

//作品收藏数量更新
export function updateScWorkKeepList(params) {
  return request({
    url: "/api/update/sc/work/keep/list",
    data: qs.stringify(params),
    method: "post",
  });
}

//社区首页作品查询
export function getZoneIndexWorkList(params) {
  return request({
    url: "/api/get/zone/index/work/list",
    params,
    method: "get",
  });
}

//社区更多作品
export function getZoneFindMoreWorkList(params) {
  return request({
    url: "/api/get/zone/find/more/work/list",
    params,
    method: "get",
  });
}
//获得点赞作品列表
export function getUserZanWorkList(params) {
  return request({
    url: "/api/get/user/zan/work/list",
    params,
    method: "get",
  });
}
//获得收藏作品列表
export function getUserKeepWorkList(params) {
  return request({
    url: "/api/get/user/keep/work/list",
    params,
    method: "get",
  });
}

//推优作业 换一批
export function getZoneIndexFindMoreTchWorkList(params) {
  return request({
    url: "/api/get/zone/index/find/more/tch/work/list",
    params,
    method: "get",
  });
}

//社区首页-学员创作榜
export function getSchoolCreateWorkStuList(params) {
  return request({
    url: "/api/get/school/create/work/stu/list",
    params,
    method: "get",
  });
}

//社区首页-学员获赞榜
export function getSchoolZanStuList(params) {
  return request({
    url: "/api/get/school/zan/stu/list",
    params,
    method: "get",
  });
}

//获得某个学员的自由创作作品
export function getOneUserWorkList(params) {
  return request({
    url: "/api/get/one/user/work/list",
    params,
    method: "get",
  });
}

//社区作品评论
export function addScWorkComment(params) {
  return request({
    url: "/api/add/sc/work/comment",
    data: qs.stringify(params),
    method: "post",
  });
}
//查询作品评论
export function getScWorkCommentList(params) {
  return request({
    url: "/api/get/sc/work/comment/list",
    params,
    method: "get",
  });
}
//删除自由创作作品
export function deleteScWork(params) {
  return request({
    url: "/api/delete/sc/work",
    data: qs.stringify(params),
    method: "post",
  });
}

//添加作品评论接口

export function addScWorkCommentReplay(params) {
  return request({
    url: "/api/add/sc/work/comment/replay",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除1级评论
export function deleteScWorkComment(params) {
  return request({
    url: "/api/delete/sc/work/comment",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除二级评论
export function deleteScWorkCommentReplay(params) {
  return request({
    url: "/api/delete/sc/work/comment/replay",
    data: qs.stringify(params),
    method: "post",
  });
}

//获取校区社区轮播图
export function zoneGetZoneBannerList(params) {
  return request({
    url: "/api/zone/get/zone/banner/list",
    params,
    method: "get",
  });
}

//社区获得作品标签
export function getWorkTagList(params) {
  return request({
    url: "/api/get/work/tag/list",
    params,
    method: "get",
  });
}


//社区获得校区科目
export function getZoneSchoolSubjectList(params) {
  return request({
    url: "/api/get/zone/school/subject/list",
    params,
    method: "get",
  });
}
//获得学生作品对应的科目列表
export function stuGetStuWorkSubject(params) {
  return request({
    url: "/api/stu/get/stu/work/subject",
    params,
    method: "get",
  });
}
//获得学生科目
export function stuGetStuSubjectAuth(params) {
  return request({
    url: "/api/stu/get/stu/subject/auth",
    params,
    method: "get",
  });
}

//社区首页-星级榜
export function getSchoolStarStuList(params) {
  return request({
    url: "/api/get/school/star/stu/list",
    params,
    method: "get",
  });
}

//删除JRCODE 自由创作作品
export function deleteJrWork(params) {
  return request({
    url: "/api/delete/jr/work",
    data: qs.stringify(params),
    method: "post",
  });
}


//删除PYTHON 自由创作作品
export function deletePyWork(params) {
  return request({
    url: "/api/delete/py/work",
    data: qs.stringify(params),
    method: "post",
  });
}

//python点赞
export function updatePyWorkZanList(params) {
  return request({
    url: "/api/update/py/work/zan/list",
    data: qs.stringify(params),
    method: "post",
  });
}

//python获得作品详情
export function getPyWorkContent(params) {
  return request({
    url: "/api/get/py/work/content",
    params,
    method: "get",
  });
}

//python作品收藏
export function updatePyWorkKeepList(params) {
  return request({
    url: "/api/update/py/work/keep/list",
    data: qs.stringify(params),
    method: "post",
  });
}

//python浏览量更新
export function updatePyWorkLooks(params) {
  return request({
    url: "/api/update/py/work/looks",
    data: qs.stringify(params),
    method: "post",
  });
}



